module.exports = __webpack_public_path__ + "img/PorkChile.613bd064.png";